import flywhweelSFMCUtilFactory from "@/services/flywheel-sfmc-util.js";
import Handlebars from "handlebars";

var sampleEmailContentTemplate = Handlebars.compile(`<!DOCTYPE html>
<html>
    <body>
        {{#each dataExtension}}{{field_name}}: "%%=v(AttributeValue('{{field_name}}'))=%%"<br>
        {{/each}}<br />
        <br />
        <a href="%%profile_center_url%%" alias="Update Profile">Update Profile</a>
        <custom name="opencounter" type="tracking"/>
    </body>
</html>`);

var Trigger = function(data, processStatus, creator) {
    this.data = data;
    this.processStatus = processStatus;
    ["$sfmc", "$sfmcDE", "$sfmcFolder", "$sfmcRest"].forEach((k) => {
        this[k] = creator[k];
    });
    this.email = null;
    this.emailId = null;
};
Object.assign(
    Trigger.prototype,
    {
        isClassicContent: function() {
            return this.data.properties["email_creative_properties"]["email_type"] == "Classic Content";
        },
        createSampleEmailContent: function() {
            return sampleEmailContentTemplate(this.data);
        },
        createSampleEmail: function() {
            this.processStatus.state = TriggerCreator.PROCESS_STATES.CHECKING_EMAIL;
            if (this.isClassicContent()) {
                return this.createSampleEmailClassic();
            } else {
                return this.createSampleEmailContentBuilder();
            }
        },
        createSampleEmailClassic: function() {
            return this.$sfmc.apiCall(
                "retrieve",
                {
                    "object_type": "Email",
                    "search_property": "Name",
                    "search_property_value": this.data.properties["email_creative_properties"]["name"],
                    "get_properties": ["ID", "Subject", "PreHeader"]
                }
            ).then(
                (response) => {
                    if (response.data.length > 1) {
                        return Promise.reject({
                            apiResponseRaw: response,
                            apiResponseMessage: `Email name '${this.data.properties["email_creative_properties"]["name"]}' is not unique. Multiple emails exist with this name`
                        });
                    } else if (response.data.length == 0) {
                        this.processStatus.state = TriggerCreator.PROCESS_STATES.CREATING_EMAIL;
                        return this.$sfmcFolder.apiCall(
                            "create_path",
                            {
                                "path": this.data.properties["email_creative_properties"]["location"]
                            }
                        ).then(
                            (response) => {
                                return this.$sfmc.apiCall(
                                    "create",
                                    {
                                        "object_type": "Email",
                                        "properties": {
                                            "CategoryID": response.data,
                                            "CharacterSet": "utf-8",
                                            "Name": this.data.properties["email_creative_properties"]["name"],
                                            "Description": this.data.properties["email_creative_properties"]["description"],
                                            "HTMLBody": this.createSampleEmailContent(),
                                            "Subject": this.data.properties["email_creative_properties"]["name"],
                                            "EmailType": "HTML",
                                            "IsHTMLPaste": "true"
                                        }
                                    }
                                );
                            }
                        ).then(
                            (response) => {
                                this.email = response.data;
                                this.emailId = response.data["NewID"];
                                return Promise.resolve();
                            }
                        );
                    } else {
                        this.email = response.data[0];
                        this.emailId = response.data[0]["ID"];
                        return Promise.resolve();
                    }
                }
            );
        },
        createSampleEmailContentBuilder: function() {
            return this.$sfmcRest.apiCall(
                {
                    "resource": "/asset/v1/content/assets/query",
                    "method": "POST",
                    "data": {
                        "query": {
                            "property": "name",
                            "simpleOperator": "equal",
                            "value": this.data.properties["email_creative_properties"]["name"]
                        },
                        "fields": [
                            "views",
                            "data"
                        ]
                    }
                }
            ).then(
                (response) => {
                    if (response.data.items.length > 1) {
                        return Promise.reject({
                            apiResponseRaw: response,
                            apiResponseMessage: `Email name '${this.data.properties["email_creative_properties"]["name"]}' is not unique. Multiple emails exist with this name`
                        });
                    } else if (response.data.items.length == 0) {
                        this.processStatus.state = TriggerCreator.PROCESS_STATES.CREATING_EMAIL;
                        return this.$sfmcFolder.apiCall(
                            "create_path",
                            {
                                "path": this.data.properties["email_creative_properties"]["location"]
                            }
                        ).then(
                            (response) => {
                                return this.$sfmcRest.apiCall({
                                    "resource": "/asset/v1/content/assets",
                                    "method": "POST",
                                    "data": {
                                        "name": this.data.properties["email_creative_properties"]["name"],
                                        "category": { "id": response.data },
                                        "channels": {
                                            "email": true,
                                            "web": false
                                        },
                                        "views": {
                                            "html": {
                                                "content": this.createSampleEmailContent()
                                            },
                                            "text": {
                                                "content": "Text content:\n%%profile_center_url%%"
                                            },
                                            "subjectline": {
                                                "content": this.data.properties["email_creative_properties"]["name"]
                                            },
                                            "preheader": {}
                                        },
                                        "assetType": {
                                            "name": "htmlemail",
                                            "id": 208
                                        }
                                    }
                                });
                            }
                        ).then(
                            (response) => {
                                this.email = response.data;
                                this.emailId = response.data["data"]["email"]["legacy"]["legacyId"]
                                return Promise.resolve();
                            }
                        );
                    } else {
                        this.email = response.data["items"][0];
                        this.emailId = response.data["items"][0]["data"]["email"]["legacy"]["legacyId"];
                        return Promise.resolve();
                    }
                }
            );
        },

        createDE: function() {
            this.processStatus.state = TriggerCreator.PROCESS_STATES.CHECKING_DE;
            return this.$sfmcDE.apiCall(
                "retrieve",
                {
                    "search_property": "Name",
                    "search_property_value": this.data.properties["data_extension_properties"]["name"],
                    "get_property": "ObjectID",
                    "single_result": true
                }
            ).then(
                (response) => {
                    if (!response.data) {
                        this.processStatus.state = TriggerCreator.PROCESS_STATES.CREATING_DE;
                        return this.createDEFromTemplate();
                    } else {
                        return Promise.resolve();
                    }
                }
            );
        },
        createDEFromTemplate: function() {
            return this.$sfmc.apiCall(
                "retrieve",
                {
                    "object_type": "DataExtensionTemplate",
                    "search_property": "Name",
                    "search_property_value": "TriggeredSendDataExtension",
                    "get_property": "ObjectID",
                    "single_result": true
                }
            ).then(
                (response) => {
                    var properties = {
                        "IsSendable": "true",
                        "IsTestable": "false",
                        "SendableDataExtensionField": {
                            "Name": (
                                (this.data.properties["data_extension_properties"]["subscriber_relationship"] == "Subscriber Key") ?
                                "SubscriberKey" :
                                "EmailAddress"
                            )
                        },
                        "SendableSubscriberField": {
                            "Name": (
                                (this.data.properties["data_extension_properties"]["subscriber_relationship"] == "Subscriber Key") ?
                                "Subscriber Key" :
                                "Email Address"
                            )
                        },
                        "Template": {
                            "ObjectID": response.data["ObjectID"]
                        },
                        "Fields": {
                            "Field": []
                        }
                    };
                    var fields = properties["Fields"]["Field"]

                    this.data.dataExtension.forEach((fieldData) => {
                        if (fieldData["template_field"]) {
                            return;
                        }
                        var field = {
                            "Name": fieldData["field_name"],
                            "IsRequired": !fieldData["nullable"] ? "true" : "false",
                            "IsPrimaryKey": fieldData["primary_key"] ? "true" : "false",
                            "FieldType": fieldData["type"]
                        };

                        if (fieldData["default_value"].length) {
                            field["DefaultValue"] = fieldData["default_value"]
                        }

                        if (
                            (field["FieldType"] == "Text") ||
                            (field["FieldType"] == "Decimal") ||
                            (field["FieldType"] == "EmailAddress")
                        ) {
                            if (fieldData["max_length"].length) {
                                field["MaxLength"] = fieldData["max_length"];
                            }
                        }

                        if (
                            (field["FieldType"] == "Decimal")
                        ) {
                            field["Scale"] = fieldData["decimal_places"]
                        }

                        fields.push(field);
                    });

                    return this.$sfmcDE.apiCall(
                        "create",
                        {
                            "path": this.data.properties["data_extension_properties"]["location"],
                            "name": this.data.properties["data_extension_properties"]["name"],
                            "customer_key": this.data.properties["data_extension_properties"]["external_key"],
                            "description": this.data.properties["data_extension_properties"]["description"],
                            "properties": properties
                        }
                    );
                }
            )
        },
        
        publish: function() {
            return this.$sfmc.apiCall(
                "retrieve",
                {
                    "search_property": "Name",
                    "search_property_value": this.data.properties["trigger_properties"]["name"],
                    "get_properties": ["CustomerKey","TriggeredSendStatus"],
                    "object_type": "TriggeredSendDefinition",
                    "single_result": true
                }
            ).then(
                (response) => {
                    if (
                        response.data &&
                        (
                            (response.data["TriggeredSendStatus"] == "New") ||
                            (response.data["TriggeredSendStatus"] == "Inactive")
                        )
                    ) {
                        this.processStatus.state = TriggerCreator.PROCESS_STATES.PUBLISHING_TRIGGER;
                        return this.$sfmc.apiCall(
                            "update",
                            {
                                "object_type": "TriggeredSendDefinition",
                                "properties": {
                                    "Name": this.data.properties["trigger_properties"]["name"],
                                    "CustomerKey": response.data["CustomerKey"],
                                    "TriggeredSendStatus": "Active",
                                    "RefreshContent": "true"
                                },
                                "customer_key": response.data["CustomerKey"]
                            }
                        );
                    } else {
                        return Promise.resolve(false);
                    }
                }
            );
        },
        unPublish: function() {
            return this.$sfmc.apiCall(
                "retrieve",
                {
                    "search_property": "Name",
                    "search_property_value": this.data.properties["trigger_properties"]["name"],
                    "get_properties": ["CustomerKey","TriggeredSendStatus"],
                    "object_type": "TriggeredSendDefinition",
                    "single_result": true
                }
            ).then(
                (response) => {
                    if (
                        response.data &&
                        (response.data["TriggeredSendStatus"] == "Active")
                    ) {
                        this.processStatus.state = TriggerCreator.PROCESS_STATES.UNPUBLISHING_TRIGGER;
                        return this.$sfmc.apiCall(
                            "update",
                            {
                                "object_type": "TriggeredSendDefinition",
                                "properties": {
                                    "Name": this.data.properties["trigger_properties"]["name"],
                                    "CustomerKey": response.data["CustomerKey"],
                                    "TriggeredSendStatus": "Inactive"
                                },
                                "customer_key": response.data["CustomerKey"]
                            }
                        );
                    } else {
                        return Promise.resolve();
                    }
                }
            );
        },

        createTrigger: function() {
            var triggerCustomerKey = null;
            var sendClassification = null;
            var senderProfile = null;
            var dataExtension = null;
            var folderId = null;

            //
            // Get the trigger
            this.processStatus.state = TriggerCreator.PROCESS_STATES.CHECKING_TRIGGER;
            return this.$sfmc.apiCall(
                "retrieve",
                {
                    "search_property": "Name",
                    "search_property_value": this.data.properties["trigger_properties"]["name"],
                    "get_properties": ["CustomerKey"],
                    "object_type": "TriggeredSendDefinition",
                    "single_result": true
                }
            ).then(
                //
                // Store the trigger CustomerKey
                (response) => {
                    if (response.data) {
                        triggerCustomerKey = response.data["CustomerKey"]
                    }
                    return Promise.resolve();
                }
            ).then(
                //
                // Get the send classification
                () => this.$sfmc.apiCall(
                    "retrieve",
                    {
                        "search_property": "Name",
                        "search_property_value": this.data.properties["trigger_properties"]["send_classification_name"],
                        "get_properties": ["CustomerKey", "ObjectID", "SenderProfile.ObjectID"],
                        "object_type": "SendClassification",
                        "single_result": true
                    }
                )
            ).then(
                //
                // Store the result
                (response) => {
                    if (response.data) {
                        sendClassification = response.data;
                        return Promise.resolve();
                    } else {
                        return Promise.reject({
                            apiResponseRaw: response,
                            apiResponseMessage: `Could not locate Send Classification '${this.data.properties["trigger_properties"]["send_classification_name"]}'.`
                        });
                    }
                }
            ).then(
                //
                // Get the sender profile
                () => this.$sfmc.apiCall(
                    "retrieve",
                    {
                        "search_property": "ObjectID",
                        "search_property_value": sendClassification["SenderProfile"]["ObjectID"],
                        "get_properties": ["FromName", "FromAddress"],
                        "object_type": "SenderProfile",
                        "single_result": true
                    }
                )
            ).then(
                //
                // Store the result
                (response) => {
                    if (response.data) {
                        senderProfile = response.data;
                        return Promise.resolve();
                    } else {
                        return Promise.reject({
                            apiResponseRaw: response,
                            apiResponseMessage: `Could not locate Sender Profile for Send Classification '${this.data.properties["trigger_properties"]["send_classification_name"]}'.`
                        });
                    }
                }
            ).then(
                //
                // Get the data extension
                () => this.$sfmcDE.apiCall(
                    "retrieve",
                    {
                        "search_property": "Name",
                        "search_property_value": this.data.properties["data_extension_properties"]["name"],
                        "get_properties": ["Name", "ObjectID", "CustomerKey"],
                        "single_result": true
                    }
                )
            ).then(
                //
                // Store the result
                (response) => {
                    if (response.data) {
                        dataExtension = response.data;
                        return Promise.resolve();
                    } else {
                        return Promise.reject({
                            apiResponseRaw: response,
                            apiResponseMessage: `Could not locate Data Extension '${this.data.properties["data_extension_properties"]["name"]}'.`
                        });
                    }
                }
            ).then(
                //
                // Make the folder
                () => this.$sfmcFolder.apiCall(
                    "create_path",
                    {
                        "path": this.data.properties["trigger_properties"]["location"]
                    }
                )
            ).then(
                (response) => {
                    folderId = response.data;
                    return Promise.resolve();
                }
            ).then(
                () => this.unPublish()
            )./*then(
                () => {
                    console.log("sendClassification", sendClassification);
                    console.log("senderProfile", senderProfile);
                    console.log("dataExtension", dataExtension);
                    console.log("this.emailId", this.emailId);
                    console.log("this.emailId", this.email);
                    console.log("triggerCustomerKey", triggerCustomerKey);
                    return Promise.resolve();
                }
            ).*/then(
                //
                // Create/update trigger
                () => {
                    var triggerProperties = {
                        "Name": this.data.properties["trigger_properties"]["name"],
                        "CustomerKey": this.data.properties["trigger_properties"]["external_key"],
                        "Description": this.data.properties["trigger_properties"]["description"],
                        "CategoryID": folderId,
                        "SendClassification": {
                            "PartnerKey": null,
                            "ObjectID": sendClassification["ObjectID"],
                            "CustomerKey": "Default Commercial"
                        },
                        "FromName": senderProfile["FromName"],
                        "FromAddress": senderProfile["FromAddress"],
                        "SuppressTracking": "false",
                        "TriggeredSendType": "Continuous",
                        "TriggeredSendStatus": "New",
                        "Email": {
                            "PartnerKey": null,
                            "ID": this.emailId,
                            "ObjectID": null
                        },
                        "List": {
                            "PartnerKey": null,
                            "ID": this.data.properties["trigger_properties"]["subscriber_list_id"],
                            "ObjectID": null
                        },
                        "AutoAddSubscribers": (
                            (this.data.properties["trigger_properties"]["add_subscribers_to_the_list"].toLowerCase() == "true") ?
                            "true" :
                            "false"
                        ),
                        "AutoUpdateSubscribers":  (
                            (this.data.properties["trigger_properties"]["update_subscribers"].toLowerCase() == "true") ?
                            "true" :
                            "false"
                        ),
                        "BatchInterval": "0",
                        "BccEmail": null,
                        "EmailSubject": (
                            this.isClassicContent() ?
                            this.email["Subject"] :
                            this.email["views"]["subjectline"]["content"]
                        ),
                        "DynamicEmailSubject": (
                            this.isClassicContent() ?
                            this.email["Subject"] :
                            this.email["views"]["subjectline"]["content"]
                        ),
                        "PreHeader": (
                            this.isClassicContent() ?
                            this.email["PreHeader"] :
                            this.email["views"]["preheader"]["content"]
                        ),
                        "IsMultipart": "true",
                        "IsWrapped": "true",
                        "AllowedSlots": "0",
                        "NewSlotTrigger": "0",
                        "SendSourceDataExtension": {
                            "Name": dataExtension["Name"],
                            "CustomerKey": dataExtension["CustomerKey"],
                            "ObjectID": dataExtension["ObjectID"]
                        }
                    };

                    if (triggerCustomerKey) {
                        this.processStatus.state = TriggerCreator.PROCESS_STATES.UPDATING_TRIGGER;
                        return this.$sfmc.apiCall(
                            "update",
                            {
                                "object_type": "TriggeredSendDefinition",
                                "properties": triggerProperties,
                                "customer_key": triggerCustomerKey
                            }
                        );
                    } else {
                        this.processStatus.state = TriggerCreator.PROCESS_STATES.CREATING_TRIGGER;
                        return this.$sfmc.apiCall(
                            "create",
                            {
                                "object_type": "TriggeredSendDefinition",
                                "properties": triggerProperties
                            }
                        );
                    }
                }
            ).then(
                () => {
                    this.processStatus.state = TriggerCreator.PROCESS_STATES.PUBLISHING_TRIGGER;
                    return this.publish();
                }
            ).then(
                () => {
                    this.processStatus.state = TriggerCreator.PROCESS_STATES.DONE;
                    return Promise.resolve();
                }
            );
        }
    }
);

export var TriggerCreator = function(component) {
    this.component = component;
    this.$sfmc = flywhweelSFMCUtilFactory(component, "sfmc");
    this.$sfmcDE = flywhweelSFMCUtilFactory(component, "de");
    this.$sfmcFolder = flywhweelSFMCUtilFactory(component, "folder");
    this.$sfmcRest = flywhweelSFMCUtilFactory(component, "rest");
};
Object.assign(
    TriggerCreator,
    {
        PROCESS_STATES: {
            IDLE: "Idle",
            QUEUED: "Queued...",
            CHECKING_EMAIL: "Checking email creative...",
            CREATING_EMAIL: "Creating sample email...",
            CHECKING_DE: "Checking data extension...",
            CREATING_DE: "Creating data extension...",
            UNPUBLISHING_TRIGGER: "Unpublishing trigger...",
            PUBLISHING_TRIGGER: "Publishing trigger...",
            CHECKING_TRIGGER: "Checking trigger...",
            CREATING_TRIGGER: "Creating trigger...",
            UPDATING_TRIGGER: "Updating trigger...",
            ERROR: "ERROR",
            DONE: "Done."
        }
    }
);
Object.assign(
    TriggerCreator.prototype,
    {
        create: function(data, processStatus) {
            var trigger = new Trigger(data, processStatus, this);
            //console.log(JSON.stringify(data, null, 4));
            //console.log(JSON.stringify(options, null, 4));
            return trigger.createSampleEmail(
            ).then(
                () => trigger.createDE()
            ).then(
                () => trigger.createTrigger()
            ).then(
                () => {
                    return Promise.resolve();
                }
            );
        }
    }
)
export default function(component) {
    return new TriggerCreator(component);
}